import { useState, useRef, useEffect, useCallback } from "react";
import "../CSS/testimonials.css";
import AnimatedContent from "../Component/AnimatedContent";
// import '../CSS/style.css';

const testimonials = [
  {
    id: 1,
    name: "Vikash kanade",
    role: "Accuduck",
    quote: "A reliable partner for our growth.",
  },
  {
    id: 2,
    name: "Manish",
    role: "M.ark Design",
    quote: "They delivered on time and exceeded expectations.",
  },
  {
    id: 3,
    name: "Harsh",
    role: "Horizonte Polaris-Spain",
    quote: "Clear communication and great results.",
  },
  {
    id: 4,
    name: "Rushikesh",
    role: "Ad-Agency",
    quote: "Thoughtful strategy and clean execution.",
  },
  {
    id: 5,
    name: "Manoj",
    role: "mDesiEng",
    quote: "Would recommend them to any founder.",
  },
];

export default function Testimonials() {
  const [index, setIndex] = useState(0);
  const total = testimonials.length;
  const regionRef = useRef(null);

  // const next = () => setIndex((i) => (i + 1) % total);
  // const prev = () => setIndex((i) => (i - 1 + total) % total);

  const next = useCallback(() => {
    setIndex((i) => (i + 1) % total);
  }, [total]);

  const prev = useCallback(() => {
    setIndex((i) => (i - 1 + total) % total);
  }, [total]);

  const goTo = (i) => setIndex(i);

  const [isPaused, setIsPaused] = useState(false);

  const handleMouseEnter = () => setIsPaused(true);
  const handleMouseLeave = () => setIsPaused(false);
  const handleFocusIn = () => setIsPaused(true);
  const handleFocusOut = () => setIsPaused(false);

  useEffect(() => {
    if (isPaused) return;

    const id = setInterval(() => {
      setIndex((i) => (i + 1) % total);
    }, 4000); // 4s per slide

    return () => clearInterval(id);
  }, [isPaused, total]);

  // Keyboard support on the region
  // useEffect(() => {
  //   const el = regionRef.current;
  //   if (!el) return;
  //   const onKey = (e) => {
  //     if (e.key === "ArrowRight") next();
  //     if (e.key === "ArrowLeft") prev();
  //   };
  //   el.addEventListener("keydown", onKey);
  //   return () => el.removeEventListener("keydown", onKey);
  // }, [total]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const el = regionRef.current;
    if (!el) return;

    const onKey = (e) => {
      if (e.key === "ArrowRight") next();
      if (e.key === "ArrowLeft") prev();
    };

    el.addEventListener("keydown", onKey);
    return () => el.removeEventListener("keydown", onKey);
  }, [next, prev]);
  const t = testimonials[index];

  return (
    <section
      className="testimonials container testimonial_container"
      // role="region"
      aria-roledescription="carousel"
      aria-label="Customer testimonials"
      aria-live="polite"
      tabIndex={0}
      ref={regionRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onFocus={handleFocusIn}
      onBlur={handleFocusOut}
    >
      <header className="section-header text-center">
        <AnimatedContent>
          <h2>Testimonials</h2>
        </AnimatedContent>
      </header>
      <AnimatedContent delay={0.2}>
        <div className="testimonial-card">
          <blockquote className="quote">{t.quote}</blockquote>
          <div className="meta">
            <h3 className="name">{t.name}</h3>
            <p className="role">{t.role}</p>
          </div>
        </div>
      </AnimatedContent>

      <AnimatedContent delay={0.4}>
        <div className="controls">
          <button
            type="button"
            className="btn-nav prev"
            onClick={prev}
            aria-label="Previous testimonial"
          >
            ‹
          </button>

          <ul className="dots">
            {testimonials.map((_, i) => (
              <li key={i}>
                <button
                  className={`dot ${i === index ? "active" : ""}`}
                  onClick={() => goTo(i)}
                />
              </li>
            ))}
          </ul>

          <button
            type="button"
            className="btn-nav next"
            onClick={next}
            aria-label="Next testimonial"
          >
            ›
          </button>
        </div>
      </AnimatedContent>
    </section>
  );
}
